import { useState } from "react";
import { toast } from "sonner";
import { AlertTriangle } from "lucide-react";
import { api, errMsg } from "../lib/api";
import { Block } from "./Common";

const PHRASE = "RESET SEMUA DATA";

export default function PanelReset({ meName, onDone }) {
  const [open, setOpen] = useState(false);
  const [text, setText] = useState("");
  const [pin, setPin] = useState("");
  const [busy, setBusy] = useState(false);
  const go = async () => {
    setBusy(true);
    try {
      const r = await api.post("/admin/reset-all", { confirm: text, pin });
      toast.success(`Semua data dikosongkan. Cadangan: ${r.data.safetyBackup}`);
      setOpen(false); setText(""); setPin("");
      onDone();
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <Block title="Kosongkan semua data (khusus Manager)" testid="panel-reset">
      <p className="text-sm text-[#4a3d3e]">
        Menghapus semua anggota (kecuali akun Anda, {meName}), laporan, riwayat, blocker, komentar, cuti, log pengingat, dan log aktivitas.
        Pengaturan, daftar program, dan file backup tetap ada. Data sekarang otomatis dibackup dulu.
      </p>
      {!open ? (
        <button data-testid="reset-open" onClick={() => setOpen(true)} className="btn-ghost mt-3 text-brand"><AlertTriangle size={15} /> Kosongkan semua data…</button>
      ) : (
        <div className="mt-3 grid gap-2 rounded-xl border border-brand bg-brand-soft p-3" data-testid="reset-confirm">
          <label className="text-xs font-semibold" htmlFor="reset-phrase">Ketik <b>{PHRASE}</b></label>
          <input id="reset-phrase" data-testid="reset-phrase" className="field" value={text} onChange={(e) => setText(e.target.value)} placeholder={PHRASE} />
          <label className="text-xs font-semibold" htmlFor="reset-pin">PIN Anda</label>
          <input id="reset-pin" data-testid="reset-pin" className="field tracking-[0.4em]" type="password" inputMode="numeric" maxLength={6}
            value={pin} onChange={(e) => setPin(e.target.value.replace(/\D/g, ""))} />
          <div className="flex gap-2">
            <button data-testid="reset-confirm-button" disabled={busy || text !== PHRASE || pin.length < 4} onClick={go} className="btn-primary flex-1">
              {busy ? "Mengosongkan…" : "Kosongkan sekarang"}
            </button>
            <button data-testid="reset-cancel" onClick={() => { setOpen(false); setText(""); setPin(""); }} className="btn-ghost">Batal</button>
          </div>
        </div>
      )}
    </Block>
  );
}
